'use strict';

import Endpoint from './Endpoint';

/**
 * @property {string}     caption
 * @property {boolean}    deprecated
 * @property {string}     deprecationNotice
 * @property {string}     description
 * @property {Endpoint[]} endpoints
 * @property {boolean}    hidden
 * @property {string}     id
 * @property {boolean}    internal
 * @property {string}     minimumVersion
 * @property {string}     name
 */
class Resource {

  /**
   * @param {string}   caption
   * @param {boolean}  deprecated
   * @param {string}   deprecationNotice
   * @param {string}   description
   * @param {Object[]} endpoints
   * @param {boolean}  hidden
   * @param {string}   id
   * @param {boolean}  internal
   * @param {string}   minimumVersion
   * @param {string}   name
   * @param {Api}      api
   */
  constructor ( {
                  caption,
                  deprecated,
                  deprecationNotice,
                  description,
                  endpoints,
                  hidden,
                  id,
                  internal,
                  minimumVersion,
                  name,
                }, api ) {
    this.caption           = caption;
    this.deprecated        = deprecated;
    this.deprecationNotice = deprecationNotice;
    this.description       = description;
    this.endpoints         = endpoints.map(endpointData => new Endpoint(endpointData, this));
    this.hidden            = hidden;
    this.id                = id;
    this.internal          = internal;
    this.name              = name;
    this.minimumVersion    = minimumVersion || 1;
    this.api               = api;
  }

  get slug () {
    return this.name
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
      .toLowerCase();
  }
}

export default Resource;
